import { onBeforeUnmount, ref, watch, type Ref } from 'vue'

/** Offer a downloaded update without taking focus from a form or another dialog. */
export function useAppUpdatePrompt(bundleId: Readonly<Ref<string | undefined>>) {
  const open = ref(false)
  let offeredId: string | undefined
  let retry: ReturnType<typeof setTimeout> | undefined

  const offer = () => {
    clearTimeout(retry)
    const id = bundleId.value
    if (!id || id === offeredId) return
    if (!open.value) {
      const focused = document.activeElement
      const editing = focused instanceof HTMLElement && focused.matches('input, textarea, select, [contenteditable="true"]')
      const otherDialog = Array.from(document.querySelectorAll('[role="dialog"]'))
        .some(dialog => dialog.getClientRects().length > 0)
      if (editing || otherDialog || document.visibilityState === 'hidden') {
        retry = setTimeout(offer, 1000)
        return
      }
    }
    offeredId = id
    open.value = true
  }

  const stop = watch(bundleId, offer, { immediate: true, flush: 'post' })
  onBeforeUnmount(() => {
    stop()
    clearTimeout(retry)
  })
  return { open }
}
